import React from "react";
import ContactUsForm from "../ContactUsPage/ContactUsForm";

const ContactFormSection = () => {
  return (
    <div className=" lg:mx-auto border-2 bg-pure-greys-150 rounded-xl">
      <h1 className="text-center text-4xl font-semibold text-richblack-700  p-2">Get in Touch</h1>
      <p className="text-center text-richblack-500 mt-3 mx-2">
        We&apos;d love to here for you, Please fill out this form.
      </p>
      <div className="mt-12  mb-2">
        <ContactUsForm />
      </div>
    </div>
  );
};

export default ContactFormSection;
